import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("fp_token");
      localStorage.removeItem("fp_user");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
        window.location.href = "/login";
      }
    } else if (status === 402) {
      // Trial expired / no active subscription — bounce user to billing.
      // Guard with a session flag so we only redirect once per page load.
      if (!window.__fp_402_redirected && window.location.pathname !== "/billing") {
        window.__fp_402_redirected = true;
        window.location.href = "/billing?trial_expired=1";
      }
    }
    return Promise.reject(err);
  }
);
